import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.0001 1.6001C4.4401 1.6001 1.6001 4.4401 1.6001 8.0001C1.6001 11.5601 4.4401 14.4001 8.0001 14.4001C11.5601 14.4001 14.4001 11.5601 14.4001 8.0001C14.4001 4.4401 11.5601 1.6001 8.0001 1.6001ZM7.3841 4.1041C7.5521 3.9361 7.6961 3.8241 7.9681 3.8241C8.2721 3.8001 8.5521 3.9441 8.6641 4.1601C8.7921 4.3121 8.8641 4.6481 8.8321 4.8481C8.8321 4.9041 8.7921 5.2801 8.7761 5.3841L8.5521 8.2241C8.5521 8.5041 8.4961 8.7841 8.3841 9.0001C8.3281 9.1681 8.1601 9.2801 7.9361 9.2801C7.7681 9.2801 7.6001 9.1681 7.5441 9.0001C7.4321 8.7201 7.3761 8.4961 7.3761 8.2241L7.2241 5.4401C7.2031 5.2511 7.18997 5.1566 7.18177 5.09754C7.17681 5.06182 7.17365 5.03907 7.17163 5.01621C7.1681 4.97606 7.1681 4.93561 7.1681 4.8241C7.1681 4.5521 7.2241 4.3281 7.3841 4.1041ZM8.0561 12.1761C8.2241 12.1761 8.4481 12.1201 8.6161 11.9521C8.7761 11.7841 8.8321 11.5601 8.8401 11.2881C8.8401 11.0641 8.7841 10.8401 8.6161 10.6721C8.4481 10.5041 8.2241 10.3921 8.0001 10.3921C7.7761 10.3921 7.5521 10.5041 7.3841 10.6721C7.2161 10.8401 7.1601 11.0641 7.1601 11.2881C7.1601 11.5601 7.2721 11.7841 7.4401 11.9521C7.6081 12.1201 7.8321 12.1761 8.0561 12.1761Z",
  fill: "#2B84E3"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}